<template>
    <b-table
        :data="records"
        :striped="true"
        :loading="loading"
        :mobile-cards="true"

        backend-pagination
        :total="total"
        :per-page="perPage"
        @page-change="onPageChange"
        backend-sorting
        :default-sort-direction="sortOrder"
        :default-sort="[sortField, sortOrder]"
        @sort="onSort"

        :paginated="paginated"
        :sort-icon="'chevron-up'"
    >
        <template>
            <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }">
                    {{ _.has(organisations, props.row.organisation) ? organisations[props.row.organisation].short_name : '-' }}
                </b-button>
            </b-table-column>

            <b-table-column v-slot="props" field="customer.lastname" label="Naam" width="200" :visible="type == 'overview'">
                <b-button tag="router-link" type="is-text" size="is-small" class="text-left" :to="{ name: 'CustomersRecord', params: {id: props.row.customer.id} }">
                    <span v-if="hideSensitiveData">********</span>
                    <span v-else style="line-height: 1">
                        <span style="width: 150px;display: inline-block;white-space: nowrap;overflow: hidden !important;text-overflow: ellipsis;">{{ props.row.customer.firstname }}&nbsp;{{ props.row.customer.lastname }}</span>
                        <br>
                        <span v-if="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation')" :icon="!_.isNull(props.row.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation') ? 'building' : 'people'">
                            <span style="width: 150px;display: inline-block;white-space: nowrap;overflow: hidden !important;text-overflow: ellipsis;"><strong>{{ hideSensitiveData ? '********' : props.row.customer.companyname }}</strong></span>
                        </span>
                    </span>
                </b-button>
            </b-table-column>

            <b-table-column v-slot="props" field="keyfob" label="Tag" width="100">
                <b-tooltip position="is-top" :label="!_.isNull(props.row.keyfob) && props.row.keyfob.length == 1 ? props.row.keyfob[0].tokenValue : !_.isNull(props.row.keyfob) && props.row.keyfob.length > 1 ? `${props.row.keyfob.length} stuks` : 'Geen tags'">
                    <router-link :to="{ name: 'ConnectRecord', params: {id: props.row.id}, query: { tags: true} }">
                        <b-button :type="props.row.keyfob && props.row.keyfob.length ? 'is-primary' : 'is-light'" icon-right="tag" size="is-small"></b-button>
                    </router-link>
                </b-tooltip>
            </b-table-column>

            <b-table-column v-slot="props" label="Actief" width="100">
                <b-icon v-if="props.row.date_from && props.row.date_to && new Date(props.row.date_from) <= new Date() && new Date(props.row.date_to) >= new Date()" icon="check" size="is-small" class="has-text-success" />
                <b-icon v-else icon="times" size="is-small" class="has-text-danger" />
            </b-table-column>

            <b-table-column v-slot="props" field="date_from" label="Toegang vanaf" sortable width="140">
                <span>{{ props.row.date_from|humanDate }}</span>
            </b-table-column>

            <b-table-column v-slot="props" field="date_to" label="Toegang tot" sortable width="140">
                <span v-if="!_.isNull(props.row.date_to)">{{ props.row.date_to|humanDate }}</span>
                <span v-else>-</span>
            </b-table-column>

            <b-table-column v-slot="props" field="contract" label="Contract">
                <b-tooltip :label="props.row.contract.finalized ? 'Contract verlopen' : 'Actief contract'" v-if="!_.isNull(props.row.contract)">
                    <router-link :to="{ name: 'ContractsRecordView', params: {id: props.row.contract.id} }">
                        <b-button :type="props.row.contract.finalized == 0 ? 'is-success' : 'is-danger'" size="is-small" icon-right="file-alt" />
                    </router-link>
                </b-tooltip>
                <span v-else>-</span>
            </b-table-column>

            <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" sortable>
                <span>{{ (props.row.updated_at || props.row.created_at)|humanDate }}</span>
            </b-table-column>

            <b-table-column v-slot="props" numeric>
                <b-button tag="router-link" type="is-dark" size="is-small" :to="'/panel/connect/'+props.row.id">Bekijken</b-button>
            </b-table-column>
        </template>

        <template #empty>
            <section class="section">
                <div class="content has-text-grey has-text-centered">
                    <p class="margin0" v-if="loading === false">Geen toegangs autorisaties gevonden.</p>

                    <p class="margin0" v-else>Laden...</p>
                </div>
            </section>
        </template>
    </b-table>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'ConnectTable',

    props: {
        type: {
            type: String,
            required: false,
            default: 'overview',
        },

        id: {
            type: Number|String,
            required: false
        }
    },

    mixins: [filtersMixin, paramsMixin],

    computed: {
        user() {
            return this.$store.state.user
        },

        paginated(){
            return this.records ? this.records.length < this.total : false
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },

        showActive() {
            return this.$store.state.showActive
        }
    },

    data() {
        return {
            loading: true,
            records: [],
            total: null,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 35,
            searchParams: typeof(this.$store.state.searchQueries['ConnectOverview']) != 'undefined' ? this.$store.state.searchQueries['ConnectOverview'] : null,
        }
    },

    created(){
        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    methods: {
        loadAsyncData(){
            // Set filter params & admin params
            let params = this.setParams(this.searchParams, 'ConnectOverview')
            let url = false

            // Always give all results when not in the overview where we use the switch
            params = params+'&showActive='+(this.type == 'overview' ? this.showActive : 'all')

            this.loading = true
            this.$emit('passLoading', true)

            switch (this.type) {
                case 'overview':
                    url = `/api/access?${params}`
                break;
                case 'box':
                    url = `/api/box/${this.id}/access?${params}`
                break;
                case 'user':
                    url = `/api/customer/${this.id}/access?${params}`
                break;
            }

            axios.get(url, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page

                this.records = response.data.data

                // Check if any record has valid dates that include today
                const today = new Date();
                const hasValidAccess = this.records.some(record => {
                    const dateFrom = record.date_from ? new Date(record.date_from) : null
                    const dateTo = record.date_to ? new Date(record.date_to) : null

                    // Access is valid if:
                    // - date_from is before/equal to today AND
                    // - either there is no date_to, or date_to is after/equal to today
                    return (!dateFrom || dateFrom <= today) &&
                           (!dateTo || dateTo >= today)
                })

                this.$emit('open', this.records.length ? hasValidAccess : null)

                this.$store.dispatch('setSearchQuery', {type: 'ConnectOverview', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching the access:', error)
                this.data = []
                this.total = null
            }).then(() => {
                this.loading = false
                this.searchParams = null

                this.$emit('connectloaded')
                this.$emit('passTotal', this.total)
                this.$emit('passLoading', false)
            })
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        },
    }
}
</script>